// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"Checkbox__checkbox___24VxY","bordered":"Checkbox__bordered___3KpV9","noMargin":"Checkbox__noMargin___PEGbE","big":"Checkbox__big___E-LYu","text":"Checkbox__text___3YeBT","signUp":"Checkbox__signUp___cC16T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/checkbox/Checkbox.scss
// module id = 1058
// module chunks = 0